<template>
	<div class="Forgot">
		<Form ref="forgotForm" class="form" :model="forgotForm" :rules="forgotRule" :label-width="80">
			<FormItem prop="email" label="邮  箱">
				<Input v-model="forgotForm.email" type="email" placeholder="Email"></Input>
			</FormItem>
			<FormItem prop="password" label="用户密码">
				<Input v-model="forgotForm.password" type="password" placeholder="Password"></Input>
			</FormItem>
			<FormItem prop="confirm_password" label="确认密码">
				<Input v-model="forgotForm.confirm_password" type="password" placeholder="Confirm Password"></Input>
			</FormItem>
			<FormItem prop="email_code" label="验证码">
				<Input v-model="forgotForm.email_code" type="text" placeholder="Email Code">
					<Button v-if="reset_email_code_second <= 0" slot="append" class="send_email_code" @click="sendEmailCode()"
					        :loading="send_email_loading" type="info">发送验证码
					</Button>
					<Button v-else slot="append" class="send_email_code" :loading="send_email_loading" @click="sendEmailCode()"
					        type="primary">
						{{reset_email_code_second}}秒后重试
					</Button>
				</Input>
			</FormItem>
			<FormItem class="handle">
				<Button @click="forgotUser('forgotForm')" class="sign-in" type="primary">提交</Button>
			</FormItem>
		</Form>
	</div>
</template>

<script>
	import {mapGetters} from "vuex";

	export default {
		name: "forgot",
		data(){
			const validatePassCheck = (rule, value, callback)=>{
				if(value !== this.forgotForm.password){
					callback(new Error('您两次输入的密码不一致'));
				}else{
					callback();
				}
			};
			return {
				forgotForm: {
					email: '',
					password: '',
					confirm_password: '',
					email_code: '',
				},
				reset_email_code_second: 0,
				send_email_loading: false,
				forgotRule: {
					username: [
						{type: 'string', required: true, message: '请输入用户名', trigger: 'blur'},
						{type: 'string', min: 4, max: 15, message: '密码的长度请保持在4至15位', trigger: 'blur'},
					],
					email: [
						{required: true, message: '请输入您的邮箱地址', trigger: 'blur'},
						{type: 'email', message: '请输入有效的邮箱格式', trigger: 'blur'},
					],
					password: [
						{required: true, message: '请输入您的登录密码.', trigger: 'blur'},
						{type: 'string', min: 6, max: 18, message: '密码的长度请保持在6至18位', trigger: 'blur'},
					],
					confirm_password: [
						{required: true, message: '请再次输入您的登录密码.', trigger: 'blur'},
						{type: 'string', min: 6, max: 18, message: '密码的长度请保持在6至18位', trigger: 'blur'},
						{validator: validatePassCheck, trigger: 'blur'},
					],
					email_code: [
						{required: true, message: '请输入您的邮箱验证码.', trigger: 'blur'},
						{type: 'string', len: 6, message: '验证码长度为6位', trigger: 'blur'},
					]
				},
				reset_interval: null,
			}
		},
		methods: {
			sendEmailCode(){
				let that = this;
				this.$refs.forgotForm.validateField('email', (valid)=>{
					if(valid === ''){
						this.$fetch.user.send_email_code({
							email: this.forgotForm.email,
						}).then((data)=>{
							this.reset_email_code_second = data.resend_time;
							this.$Notice.success({
								title: '发送成功',
							});
							this.countDown();
						}).catch((err)=>{
							//重置倒计时
							this.reset_email_code_second = err.data['retry-after'];
							this.countDown();
						})
					}
				});
			},
			countDown(){
				let that = this;
				if(this.reset_interval !== null){
					clearInterval(this.reset_interval);
				}
				this.reset_interval = setInterval(function(){
					if(that.reset_email_code_second > 0){
						that.reset_email_code_second = that.reset_email_code_second - 1;
					}else{
						that.send_email_loading = false;
						clearInterval(this.reset_interval);
					}
				}, 1000);
			},
			forgotUser(name){
				this.$refs[name].validate((valid)=>{
					if(valid){
						this.$fetch.user.user_forgot(this.forgotForm).then((data)=>{
							this.$Notice.success({
								title: '密码修改成功',
							});
							this.$router.push({name: 'Login'});
						}).catch(()=>{
						})
					}
				})
			},
			JudgeUser(){
				if(this.user instanceof Object){
					this.$router.push({name: 'DashboardCode'});
				}
			},
		},
		computed: {
			...mapGetters([
				'user',
			]),
		},
		watch: {
			"user": function(value){
				this.JudgeUser();
			}
		},
	}
</script>

<style scoped lang="less">
	.Forgot {
		padding-top: 100px;
		padding-bottom: 100px;
		
		.send_email_code {
			background-color: #1BA1E2;
			color: #fff;
			border-color: #1BA1E2;
			position: relative;
			left: 2px;
		}
		
		i {
			font-size: 20px;
		}
		
		.form {
			display: flex;
			border: 1px solid #eee;
			padding: 50px 20px;
			border-radius: 7px;
			justify-content: center;
			flex-direction: column;
			vertical-align: middle;
			width: 400px;
			margin: 0 auto;
			
			.forgot {
				margin-top: 20px;
				margin-bottom: 0;
				display: flex;
				flex-direction: row;
				justify-content: flex-end;
				
				span:hover {
					text-decoration: underline;
					cursor: pointer;
				}
			}
			
			.handle {
			}
			
			.sign-in {
				width: 230px;
			}
		}
	}
</style>